import { render, staticRenderFns } from "./TablePaginationState.vue?vue&type=template&id=025ca067&"
import script from "./TablePaginationState.vue?vue&type=script&lang=js&"
export * from "./TablePaginationState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports